<script>
import { Message } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Message',
      verboseName: 'Message',
      verboseNamePlural: 'Messages',
      fullWidth: true,
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        {
          prop: 'created',
          label: 'Date',
          formatter: this.formatDate('created')
        },
        { prop: 'first_name', label: 'First name' },
        { prop: 'last_name', label: 'Last name' },
        { prop: 'email_phone', label: 'Email/Phone' }
      ]
    }
  },
  computed: {
    service() {
      return Message
    }
  },
  methods: {
    actions(scope) {
      return [
        {
          component: 'router-link',
          attrs: {
            to: this.getEditRoute(scope.row)
          },
          children: [this.getButtonComponent({ icon: 'fa fa-edit' })]
        }
      ]
    }
  }
}
</script>
